<template>
  <svg
    width="111"
    height="24"
    viewBox="0 0 167 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ $t('blocket-logo') }}</title>
    <path
      d="M0.283905 34.854V0.151093H9.91124V8.11545C10.9451 7.90044 11.9975 7.78581 13.0536 7.77317C21.5051 7.77317 26.5627 12.4169 26.5627 21.311C26.5627 30.3073 21.1611 34.854 12.1191 34.854H0.283905ZM9.91124 26.5423H11.6775C14.9226 26.5423 16.6427 24.5397 16.6427 21.311C16.6427 18.0824 14.825 16.279 11.58 16.279C11.0188 16.2902 10.4599 16.3552 9.91124 16.4732V26.5423Z"
      fill="#F71414"
    />
    <path
      d="M38.8446 0.151093H29.2173V34.854H38.8446V0.151093Z"
      fill="#F71414"
    />
    <path
      d="M41.4991 21.5103C41.4991 12.4169 46.3102 7.77316 55.4498 7.77316C64.5893 7.77316 69.4004 12.4169 69.4004 21.5103C69.4004 30.6036 64.5842 35.3393 55.4498 35.3393C46.3154 35.3393 41.4991 30.5985 41.4991 21.5103ZM59.4702 21.5103C59.4702 18.675 58.2892 16.4732 55.4395 16.4732C52.5898 16.4732 51.4089 18.675 51.4089 21.5103C51.4089 24.3456 52.5898 26.6189 55.4395 26.6189C58.2892 26.6189 59.4702 24.3251 59.4702 21.5103Z"
      fill="#F71414"
    />
    <path
      d="M71.557 21.5103C71.557 12.611 76.6197 7.77316 85.5076 7.77316C87.8981 7.80218 90.263 8.26619 92.4855 9.14228V17.827C90.7277 17.0063 88.8236 16.541 86.8837 16.4578C83.4487 16.4578 81.4821 18.3174 81.4821 21.4949C81.4821 24.6725 83.4487 26.6036 86.8837 26.6036C88.8236 26.5204 90.7277 26.0551 92.4855 25.2345V33.9191C90.2635 34.797 87.8982 35.2611 85.5076 35.2883C76.6248 35.3393 71.557 30.4044 71.557 21.5103Z"
      fill="#F71414"
    />
    <path
      d="M105.065 34.854H95.4379V0.151093H105.065V16.9636L111.745 8.2636H123.488L114.01 19.896L123.488 34.854H111.946L105.065 23.1195V34.854Z"
      fill="#F71414"
    />
    <path
      d="M121.917 21.5103C121.917 12.514 126.882 7.77316 135.328 7.77316C143.287 7.77316 147.559 12.8818 147.559 21.1169V23.707H131.744C132.037 26.3941 134.692 27.518 138.276 27.518C141.455 27.4117 144.591 26.7619 147.549 25.5972V33.2601C144.072 34.6682 140.35 35.3817 136.597 35.3598C126.574 35.3598 121.907 30.619 121.907 21.5307M138.337 18.3021C138.337 16.2586 137.31 14.726 135.046 14.726C132.782 14.726 131.755 16.2586 131.755 18.3021H138.337Z"
      fill="#F71414"
    />
    <path
      d="M150.214 21.4132V1.41803H159.841V8.2636H166.721V16.7695H159.841V21.214C159.841 25.1272 162.408 26.4452 166.228 26.4452H166.742V34.9511C165.816 35.1102 164.878 35.1922 163.938 35.1963C154.948 35.1963 150.234 30.4044 150.234 21.403"
      fill="#F71414"
    />
  </svg>
</template>
